import React from "react";
import { Grid } from "@mui/material";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import FormField from "layouts/pages/account/components/FormField";
import SettingsCard from "./SettingsCard";
import {
  FONT_OPTIONS,
  FONT_SIZE_OPTIONS,
  FONT_DROPDOWN_STYLE,
  FONT_SIZE_DROPDOWN_STYLE,
} from "./constants/fontConstants";

const FooterStylingSection = ({ inputData }) => {
  return (
    <SettingsCard
      title="Footer Styling"
      subtitle="Configure footer styling, colors, and typography"
      gridProps={{
        xs: 12,
        sx: {
          "@media (min-width: 1100px)": {
            flexBasis: "calc(50% - 12px)",
            maxWidth: "calc(50% - 12px)",
            width: "calc(50% - 12px)"
          }
        }
      }}
    >
      <Grid container spacing={2.5}>
        <Grid item xs={6}>
          <FormField
            defaultValue={inputData?.footer_background || "#113861"}
            className="color-input"
            label="Background"
            name="footer_background"
            inputProps={{ type: "color" }}
          />
        </Grid>
        <Grid item xs={6}>
          <FormField
            defaultValue={inputData?.footer_text || "#ffffff"}
            className="color-input"
            label="Text Color"
            name="footer_text"
            inputProps={{ type: "color" }}
          />
        </Grid>
        <Grid item xs={12}>
          <SoftBox display="flex" flexDirection="row" gap={2}>
            <SoftBox display="flex" flexDirection="column" flex={1}>
              <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                <SoftTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                  textTransform="capitalize"
                >
                  Footer Font
                </SoftTypography>
              </SoftBox>
              <select
                name="footer_font"
                defaultValue={inputData?.footer_font || "Poppins"}
                style={FONT_DROPDOWN_STYLE}
              >
                {FONT_OPTIONS.map((font) => (
                  <option key={font} value={font}>
                    {font}
                  </option>
                ))}
              </select>
            </SoftBox>
            <SoftBox display="flex" flexDirection="column" flex={1}>
              <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                <SoftTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                  textTransform="capitalize"
                >
                  Font Size
                </SoftTypography>
              </SoftBox>
              <select
                name="footer_font_size"
                defaultValue={inputData?.footer_font_size || "16px"}
                style={FONT_SIZE_DROPDOWN_STYLE}
              >
                {FONT_SIZE_OPTIONS.slice(0, 6).map((size) => (
                  <option key={size} value={size}>
                    {size}
                  </option>
                ))}
              </select>
            </SoftBox>
          </SoftBox>
        </Grid>
      </Grid>
    </SettingsCard>
  );
};

export default FooterStylingSection;
